<template>
<div id="app" v-bind:class="[this.$route.matched[0] ? this.$route.matched[0].name : '', this.$route.name]">
    <MainHeader/>
    <main>
      <router-view/>
    </main>
    <MainFooter/>
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
import MainFooter from '@/components/MainFooter.vue'

export default {
  components: {
    MainHeader,
    MainFooter
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  font-family: 'Work Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

main {
  flex: 1;
  margin-top: auto;
}

</style>
